<div *ngIf="!isLogged">
  <div class="grid" [ngClass]="navBarClass">
    <div class="col-1 logo">
      <img [src]="navBarlogo">
    </div>
    <div class="col-10 motd">
      <h3 class="" [innerHTML]="getUserMessageOfTheDay()"></h3>
    </div>
    <div class="col-1">
    </div>
  </div>
  <div class="select-locale-container">
      <div class="select-locale-content">
        <p-dropdown [options]="locales" [(ngModel)]="locale" [style]="{'width':'150px'}" [filter]="true" (onChange)="updateLocale()">
          <ng-template let-item pTemplate="selectedItem">
            <img src="/assets/img/{{item.value}}.png" style="width:16px;vertical-align:middle" />
            <span style="vertical-align:middle">{{item.label}}</span>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <div class="p-helper-clearfix" style="position: relative;height: 25px;">
              <img src="/assets/img/{{item.value}}.png" style="width:24px;position:absolute;top:1px;left:5px"/>
              <div style="font-size:14px;float:right;margin-top:4px">{{item.label}}</div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
  </div>
  <app-login></app-login>
</div>

<div *ngIf="isLogged && !requirePasswordChange">
  <app-application-container></app-application-container>
</div>
<div class="grid" *ngIf="isLogged && requirePasswordChange">
  <div class="col-12">
    <div class="grid" [ngClass]="navBarClass">
      <div class="col-1 logo">
        <img [src]="navBarlogo">
      </div>
      <div class="col-10 motd">
        <h3 class="" [innerHTML]="getUserMessageOfTheDay()"></h3>
      </div>
      <div class="col-1">
      </div>
    </div>
    <div class="select-locale-container">
      <div class="select-locale-content">
        <p-dropdown [options]="locales" [(ngModel)]="locale" [style]="{'width':'150px'}" [filter]="true" (onChange)="updateLocale()">
          <ng-template let-item pTemplate="selectedItem">
            <img src="/assets/img/{{item.value}}.png" style="width:16px;vertical-align:middle" />
            <span style="vertical-align:middle">{{item.label}}</span>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <div class="p-helper-clearfix" style="position: relative;height: 25px;">
              <img src="/assets/img/{{item.value}}.png" style="width:24px;position:absolute;top:1px;left:5px"/>
              <div style="font-size:14px;float:right;margin-top:4px">{{item.label}}</div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>
  </div>
  <div class="col-4"></div>
  <div class="col-4">
    <div class="col-12">
      <h2>{{'CONFIGURATION_COMPONENT.TITLE_CHANGE_EXPIRED_PASSWORD' | translate}}</h2>
    </div>
    <div class="col-12">
      <div class="col-6">
        <h3>{{ 'CONFIGURATION_COMPONENT.LABEL_CURRENTPASSWORD' | translate }}</h3>
      </div>
      <div class="col-6">
        <form>
          <input type="password" pPassword [feedback]="false" [(ngModel)]="actualPassword" name="actualPassword"
                 autocomplete="false">
        </form>
      </div>
    </div>
    <div class="col-12">
    <app-create-password (passwordEvent)="newPassword=$event" (verifyPasswordEvent)="verifyPassword=$event"
                         (isNewPasswordValid)="isNewPasswordValid=$event"
                         (isNewPasswordConfirmValid)="isNewPasswordConfirmValid=$event"></app-create-password>

    </div>
    <div class="col-12 center">
      <button pButton type="button" (click)="changePassword()" [label]="'COMMON.VALIDATE' | translate"
              [disabled]="!formIsComplete()" class="p-button-warning"></button>
    </div>

    <div class="col-12 error">
      <div class="grid">
        <p *ngIf="changePasswordFail">{{errorMessage}}</p>
        <p *ngIf="!isNewPasswordValid">{{passwordInvalidMsg}}</p>
        <p *ngIf="!isNewPasswordConfirmValid">{{passwordConfirmInvalidMsg}}</p>
      </div>
    </div>
  </div>
  <div class="col-4"></div>
</div>

<div class="loaderModal">
  <p-dialog [(visible)]="displayLoading" [header]="'APPLICATION_COMPONENT.HEADER' | translate" id="loader" [draggable]="false" [closable]="false" [resizable]="false"
            [modal]="true" [closeOnEscape]="false">
    <app-loader waitingMessage="{{ 'APPLICATION_COMPONENT.MESSAGE' | translate }}"></app-loader>
  </p-dialog>

</div>
